'use client'

import { useState, type CSSProperties, type ReactNode } from 'react'

/**
 * Round avatar with a graceful fallback. If the profile image fails to load
 * (e.g. a 503 from the asset proxy, or a deleted/missing object), we fall back
 * to the colored initial on its gradient background instead of rendering a
 * broken-image icon. Shared across the inbox list rows and the thread view so
 * the fallback behaves identically everywhere.
 */
export function AvatarCircle({
  url,
  initial,
  bgColor,
  isSupport = false,
  size = 40,
  fontSize = 16,
  style,
}: {
  url?: string | null
  initial: ReactNode
  bgColor: string
  isSupport?: boolean
  size?: number | string
  fontSize?: number
  style?: CSSProperties
}) {
  const [failed, setFailed] = useState(false)
  const showImg = !!url && !failed

  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        background: isSupport
          ? 'white'
          : showImg
            ? 'var(--background_3, var(--separator))'
            : bgColor,
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize,
        fontWeight: 600,
        letterSpacing: '-0.01em',
        overflow: 'hidden',
        ...style,
      }}
    >
      {isSupport ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src="/assets/svg/logo.svg"
          alt="MarkitMix"
          style={{ width: '100%', height: '100%', objectFit: 'contain' }}
        />
      ) : showImg ? (
        // eslint-disable-next-line @next/next/no-img-element
        <img
          src={url as string}
          alt=""
          onError={() => setFailed(true)}
          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
        />
      ) : (
        initial
      )}
    </div>
  )
}
